<template>
  <div>
    <!-- <el-select v-model="locale" size="small" style="width:100px">
      <el-option v-for="(item,key,index) in langs" :key="index" :label="$t('locales.' + key)" :value="key">
      </el-option>
    </el-select> -->
    <el-dropdown @command="handleCommandSkin" trigger="click" class="eldropdown">
      <span class="el-dropdown-link lang">切换主题</span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(item,index) in skins" :key="index" :command="item.name">{{item.label}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

  </div>
</template>
<script>
import { global } from '@/global/global'
export default {
  name: 'skin',
  data() {
    return {
      skins: [
        { name: 'Blue', label: '天空蓝' },
        { name: 'Green', label: '典雅绿' },
        { name: 'Red', label: '樱桃红' },
        { name: 'Purple', label: '贵族紫' },
        { name: 'Default', label: '默认' }
      ]
    }
  },
  mounted() {},
  methods: {
    handleCommandSkin(command) {
      this.$store.dispatch('changeTheme', command);
      global.changeTheme(command)
    }
  }
}
</script>

<style scoped>
.lang {
  cursor: pointer;
  color:#5a5e66;
}

.eldropdown {
  margin-right: 5px;
}
.skin {
  /*margin-top: 3px;*/
  cursor: pointer;
}
</style>
